// extracted by mini-css-extract-plugin
module.exports = {"container":"JoinCompany_container__IiZxc","buttonContainer":"JoinCompany_buttonContainer__1P5RA"};